import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../../shared/modules/bs-modal/services/modal.service';

enum NextMode {
    Button = 0,
    Link = 1
}
@Component({
    selector: 'app-error-popup',
    templateUrl: './error-popup.component.html',
    styleUrls: ['./error-popup.component.scss']
})
export class ErrorPopupComponent implements OnInit {
    NextMode = NextMode;
    constructor(private modalSvc: ModalService) {}

    ngOnInit(): void {}
    next(type: NextMode): void {
        switch (type) {
            case NextMode.Button:
                this.modalSvc.closeModalAndAlertSubscribers(true);

                break;
            case NextMode.Link:
            default:
                this.modalSvc.closeModalAndAlertSubscribers(false);

                break;
        }
    }
}
